var map = {
	"./automatization.jpg": 5213,
	"./background.jpg": 7322,
	"./deckbuilder.jpg": 8356,
	"./homepage_card_1-old.jpg": 5769,
	"./homepage_card_1.jpg": 5925,
	"./homepage_card_2.jpg": 1722,
	"./homepage_card_3.jpg": 2887,
	"./homepage_card_4.jpg": 6572,
	"./homepage_card_5-old.jpg": 8733,
	"./homepage_card_5.jpg": 8185,
	"./keep-track.jpg": 3239,
	"./play.jpg": 1652
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1336;